import React from 'react'
import styled from 'styled-components'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import './styles.css';

// import required modules
import { Pagination } from 'swiper/modules';
// import styled from "styled-components";




const Wrapper =styled.section`
.section{
  padding-top: 5%;
  padding-bottom: 9%;

  h2{
    color:#EC632F;
  margin-left:21px;
  padding-bottom: 3%;
}
  .image-div-1{
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-bottom: 5%;
  }
  img{
  width: 90%;
  display: flex;
  margin: 0 auto;
}
.image-div-2{
  display: none;
}
}
a{
  margin-right:21px;
  color: #fff;
  font-weight: bold;
width: 120px;
border: none;
border-radius: 5%;
font-size: 18px;
height: 35px;
background: orange;
display: flex;
justify-content: center;
align-items: center;
float: right;
}
.image-div-3{
  display: none;
}

@media (min-width: 768px) {
  padding-top: 3%;
  padding-bottom: 3%;


  
  .section{
    .image-div-1{
    display: flex;
    flex-direction: row;
    gap: 15px;
    padding-bottom: 5%;
    img{
  width: 0%;
  display: flex;
  margin: 0 ;
}
  }
  h2{
    color:#EC632F;
  margin-left:60px;
  padding-bottom: 3%;
}

  .image-div-2{
  display: flex;
  gap: 20px;
padding-bottom:20px;
  img{
  width: 50%;
  display: flex;
  margin: 0 ;
}
}
}
.gallery{
  margin: 0 60px; 
}

.image-div-3{
  display: none;
}

a{
  margin-right:55px;
  color: #fff;
  font-weight: bold;
width: 180px;
border: none;
border-radius: 5%;
font-size: 18px;
height: 55px;
background: orange;
display: flex;
justify-content: center;
align-items: center;
float: right;
}
}





@media (min-width: 992px) {
  padding-top: 3%;
  padding-bottom: 3%;

 

  .imageAllCombo-1{
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .imageAllCombo-2{
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .section{
    h2{
    color:#EC632F;
  margin-left:42px;
}
    .image-div-1{
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding-bottom: 0%;
    img{
  width: 50%;
  display: flex;
  margin: 0 ;
}
  }
  .image-div-2{
  display: flex;
  gap: 10px;
padding-top:0px;
padding-bottom:0px;
  img{
  width: 50%;
  display: flex;
  margin: 0 ;
}
}
.image-div-3{
  display: flex;
  gap: 10px;
  img{
  width: 50%;
  display: flex;
  margin: 0 ;
}
}
}
.gallery{
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 40px;
  padding-bottom : 3%;
}
.image-div-3{
  display: none;
}

a{
  margin-right:30px;
  color: #fff;
  font-weight: bold;
width: 180px;
border: none;
border-radius: 5%;
font-size: 18px;
height: 55px;
background: orange;
display: flex;
justify-content: center;
align-items: center;
float: right;
}
}
@media (min-width: 1200px) {
  padding-top: 3%;
  padding-bottom: 2%;

 

  .imageAllCombo-1{
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .imageAllCombo-2{
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .section{
    h2{
    color:#EC632F;
  margin-left:100px;
  font-size: 33px;
  font-weight: 600;

}
    .image-div-1{
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding-bottom: 0%;
    img{
  width: 100%;
  display: flex;
  margin: 0 ;
}
  }
  .image-div-2{
  display: flex;
  gap: 20px;
padding-top:0px;
padding-bottom:0px;
  img{
  width: 100%;
  display: flex;
  margin: 0 ;
}
}
.image-div-3{
  display: flex;
  gap: 20px;
  img{
  width: 100%;
  display: flex;
  margin: 0 ;
}
}
}
.gallery{
  position: relative;
  left: 100px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0 0px;
  padding-bottom : 3%;
}
.image-div-3{
  display: none;
}

a{
  margin-right:90px;
  color: #fff;
  font-weight: bold;
width: 180px;
border: none;
border-radius: 5%;
font-size: 18px;
height: 55px;
background: orange;
display: flex;
justify-content: center;
align-items: center;
float: right;
}
}
`
function OurGallery() {
  return (
    <Wrapper>
      <div className='section'>
        <h2>Our Gallery</h2>
        <div className='gallery'>
       
          <div className='imageAllCombo-1'>
            <div className='image-div-1'>
            <img src="./photos/kidswalking.png" alt="photo"/>
            <img src="./photos/kidswalking.png" alt="photo"/>
            </div>


            <div className='image-div-2'>
            <img src="./photos/kidswalking.png" alt="photo"/>
            <img src="./photos/kidswalking.png" alt="photo"/>
            </div>

            </div>


            <div className='imageAllCombo-2'>

            <div className='image-div-2'>
            <img src="./photos/kidswalking.png" alt="photo"/>
            <img src="./photos/kidswalking.png" alt="photo"/>

            </div>



            <div className='image-div-3'>
            <img src="./photos/kidswalking.png" alt="photo"/>
            <img src="./photos/kidswalking.png" alt="photo"/>

            </div>

            </div>

        </div>
        <a>View More</a>
      </div>
    </Wrapper>
  )
}

export default OurGallery
